import {
  CurrentPlayerControl,
  PlayingSong,
  PlayerControl,
  QueueSong,
  QueuedSong,
  ReorderSong,
  SearchSong,
  SkipSong,
  Song,
  UnqueueSong,
  ToggleSongLike,
  Shuffle,
  ToggleTag,
  StuenMessage,
  SearchSongResult,
  CurrentQueue,
  CurrentSong,
  SongLikes,
  RemoveFromAutoPlay,
  SearchHistory, HistoryContent, SetCutoff, TagFrequencyList, TagFrequency, ChangeTagFrequency,
} from "stuen-common";
import { ws } from "./api";
import { isSearcingSongs, songs } from "../state/songSearch";
import { isSearcingHistory, historySongs } from "../state/historySearch";
import { useMockApi, userName } from "../state/global";
import { queue } from "../state/queue";
import {
  currentPlayerControl,
  currentSong,
  currentSongUniqueId,
} from "../state/player";
import { songLikes } from "../state/songLikes";
import { addSongToPlaylist, removeSongFromPlaylist } from "./playlist";
import {tagFrequencies} from "../state/tagFrequencies";

export const handleSongEvents = (socketMessage: StuenMessage) => {
  if (socketMessage instanceof SearchSongResult) {
    isSearcingSongs.value = false;
    songs.value = [...socketMessage.result];
  }
  if (socketMessage instanceof CurrentQueue) {
    queue.value = [...socketMessage.songs];
  }
  if (socketMessage instanceof CurrentSong) {
    currentSong.value = socketMessage.song || null;
  }
  if (socketMessage instanceof CurrentPlayerControl) {
    const previousControl = currentPlayerControl.value;
    const nextControl = socketMessage.playerControl;
    if (
      previousControl?.type !== nextControl?.type ||
      previousControl?.songId !== nextControl?.songId
    ) {
      currentSongUniqueId.value = nextControl ? crypto.randomUUID() : null;
    }
    currentPlayerControl.value = nextControl || null;
  }
  if (socketMessage instanceof SongLikes) {
    songLikes.value = socketMessage.listeners;
  }
  if (socketMessage instanceof HistoryContent) {
    isSearcingHistory.value = false;
    historySongs.value = [...socketMessage.result];
  }
  
  if (socketMessage instanceof TagFrequencyList) {
    tagFrequencies.value = [...socketMessage.tags];
  }
};

export const searchSong = (message: string) => {
  if (useMockApi.value) {
    songs.value = [
      {
        type: 0,
        title:
          "Passenger - Let Her Go (Feat. Ed Sheeran - Anniversary Edition) [Official Video]",
        songId: "HTcL9WkB_wg",
        image: `http://i3.ytimg.com/vi/HTcL9WkB_wg/hqdefault.jpg`,
        tags: [],
        inAutoPlay: true,
        plays: 0,
        cutOff: null
      },
      {
        type: 0,
        title:
          "Cozy Fireplace 🔥 A peaceful night next to a soothing fireplace to cure insomnia and relieve stress",
        songId: "33sq6cZ_WUM",
        image: `http://i3.ytimg.com/vi/33sq6cZ_WUM/hqdefault.jpg`,
        tags: [],
        inAutoPlay: false,
        plays: 0,
        cutOff: null
      },
    ];
  } else {
    isSearcingSongs.value = true;
    ws?.send(JSON.stringify(new SearchSong(message)));
  }
};

export const searchHistory = (message: string) => {
  if (useMockApi.value) {
    historySongs.value = [
      {
        type: 0,
        title:
          "Passenger - Let Her Go (Feat. Ed Sheeran - Anniversary Edition) [Official Video]",
        songId: "HTcL9WkB_wg",
        image: `http://i3.ytimg.com/vi/HTcL9WkB_wg/hqdefault.jpg`,
        tags: [],
        inAutoPlay: true,
        plays: 0,
        cutOff: null
      },
      {
        type: 0,
        title:
          "Cozy Fireplace 🔥 A peaceful night next to a soothing fireplace to cure insomnia and relieve stress",
        songId: "33sq6cZ_WUM",
        image: `http://i3.ytimg.com/vi/33sq6cZ_WUM/hqdefault.jpg`,
        tags: [],
        inAutoPlay: false,
        plays: 0,
        cutOff: null
      },
    ];
  } else {
    isSearcingHistory.value = true;
    ws?.send(JSON.stringify(new SearchHistory(message)));
  }
};

export const queueSong = (song: Song) => {
  if (useMockApi.value) {
    if (!currentSong.value) {
      currentSongUniqueId.value = crypto.randomUUID();
      currentSong.value = {
        ...song,
        listener: userName.value || "Test",
      };
      currentPlayerControl.value = new PlayerControl(song.type, song.songId, 0, 100);
    } else {
      queue.value = [
        ...queue.value,
        {
          ...song,
          listener: userName.value || "Test",
        },
      ];
    }
  } else {
    ws?.send(JSON.stringify(new QueueSong(song)));
  }
};
export const setTagFrequency = (tagFrequency: TagFrequency) => {
  if (useMockApi.value) {
    console.warn("not implemented")
  } else {
    ws?.send(JSON.stringify(new ChangeTagFrequency(tagFrequency)));
  }
};

export const queueSongs = (songs: Song[]) => {
  songs.forEach((song) => {
    queueSong(song);
  });
};

export const unqueueSong = (position: number, all?: boolean) => {
  if (useMockApi.value) {
    queue.value = queue.value.filter((_, index) => index !== position);
  } else {
    ws?.send(JSON.stringify(new UnqueueSong(position, all)));
  }
};

export const skipSong = () => {
  if (useMockApi.value) {
    const firstSongInQueue = queue.value[0];
    if (firstSongInQueue) {
      queue.value = queue.value.filter((_, index) => index !== 0);
      currentSongUniqueId.value = crypto.randomUUID();
      currentSong.value = {
        ...firstSongInQueue,
        listener: userName.value || "Test",
      };
      currentPlayerControl.value = new PlayerControl(
        firstSongInQueue.type,
        firstSongInQueue.songId,
        0,
        100,
      );
    } else {
      currentSong.value = null;
      currentPlayerControl.value = null;
      currentSongUniqueId.value = null;
    }
  } else {
    ws?.send(JSON.stringify(new SkipSong()));
  }
};

export const shuffle = () => {
  if (useMockApi.value) {
    console.log("Mock not implemented");
  } else {
    ws?.send(JSON.stringify(new Shuffle()));
  }
};

export const removeSongFromAutoPlay = () => {
  if (useMockApi.value) {
    console.log("Mock not implemented");
  } else {
    ws?.send(JSON.stringify(new RemoveFromAutoPlay()));
  }
};

export const setCutoff = () => {
  if (useMockApi.value) {
    console.log("Mock not implemented");
  } else {
    ws?.send(JSON.stringify(new SetCutoff()));
  }
};

export const toggleLikeSong = () => {
  if (useMockApi.value) {
    songLikes.value = songLikes.value.includes(userName.value || "Test")
      ? songLikes.value.filter(
          (listener) => listener !== userName.value || "Test",
        )
      : [...songLikes.value, userName.value || "Test"];
  } else {
    ws?.send(JSON.stringify(new ToggleSongLike()));
  }
};

export const reorderSong = (positionToMove: number, placePosition: number) => {
  if (useMockApi.value) {
  } else {
    ws?.send(JSON.stringify(new ReorderSong(positionToMove, placePosition)));
  }
};

export const addSongToFavorites = (song: Song | PlayingSong | QueuedSong) => {
  addSongToPlaylist(song, "favorites");
};

export const removeSongFromFavorites = (
  song: Song | PlayingSong | QueuedSong,
) => {
  removeSongFromPlaylist(song, "favorites");
};

export const toggleTag = (song: Song, tag: string) => {
  if (useMockApi.value) {
  } else {
    ws?.send(JSON.stringify(new ToggleTag(song, tag)));
  }
};
